import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import * as api from '../../api/app/localUserApi';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useTranslation } from '../../contexts/translation';
import { LocalUserCreateRequest, LocalUserInputs } from '../../types/app/localUser.types';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/localUser.functions';
import { LocalUserForm } from './LocalUserForm';
import { useStyles } from './LocalUserForm.styles';

export function LocalUserCreate() {
  const { t } = useTranslation();
  const classes = useStyles();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { mutate: mutateCreateLocalUser } = useMutation(api.createItem);

  const defaultValues: LocalUserInputs = {
    id: '',
    email: '',
    name: '',
    password: '',
  };

  const handleOnSubmit: SubmitHandler<LocalUserInputs> = (data: LocalUserInputs) => {
    const requestData: LocalUserCreateRequest = convertDataFromInputToCreateRequest(data);

    mutateCreateLocalUser(
      { ...requestData, password: encodeURIComponent(requestData.password) },
      {
        onSuccess: () => {
          enqueueSnackbar(t('page.local-user.item-created'), { variant: 'success' });
          navigate(`/localUser`);
          queryClient.invalidateQueries(['localUser']);
        },
        onError: (result) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <PageHeader title={t('page.local-user.headline-create')} />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <LocalUserForm
                onSubmit={handleOnSubmit}
                onBack={() => navigate('/localUser')}
                defaultValues={defaultValues}
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
